module.exports = __webpack_public_path__ + "img/sesiones.d3977548.svg";